export default "__VITE_ASSET__312d3b5a__"